export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7348.f8586038.jpg";